'use client';
import { useEffect } from 'react';
import { useShallow } from 'zustand/react/shallow';

import { useCommonStore } from '@/store';

interface usePromotionsMenuDataParams {
  locale: string;
  disableOnMobile?: boolean;
}

export const usePromotionsMenuData = ({
  locale,
  disableOnMobile,
}: usePromotionsMenuDataParams) => {
  const {
    cmsConfig,
    isMobileDevice,
    fetchScratchGameMenuData,
    fetchBonanzaPromoMenuData,
    fetchFortuneWheelMenuData,
  } = useCommonStore(
    useShallow((state) => ({
      cmsConfig: state.cmsConfig,
      isMobileDevice: state.isMobileDevice,
      fetchScratchGameMenuData: state.fetchScratchGameMenuData,
      fetchBonanzaPromoMenuData: state.fetchBonanzaPromoMenuData,
      fetchFortuneWheelMenuData: state.fetchFortuneWheelMenuData,
    }))
  );

  useEffect(() => {
    if (!cmsConfig || (disableOnMobile && isMobileDevice)) return;

    if (cmsConfig.bonanzaPromo.availableByDate) {
      fetchBonanzaPromoMenuData(locale);
    }

    if (cmsConfig.scratchGame.availableByDate) {
      fetchScratchGameMenuData(locale);
    }

    if (cmsConfig.fortuneWheel.availableByDate) {
      fetchFortuneWheelMenuData(locale);
    }
  }, [
    locale,
    cmsConfig,
    isMobileDevice,
    disableOnMobile,
    fetchScratchGameMenuData,
    fetchBonanzaPromoMenuData,
    fetchFortuneWheelMenuData,
  ]);
};
